<div class="flex flex-col" [id]="(simplifiedContext() ?? 'notes').toLowerCase() + '-side-notes-container'">
    <!-- add h-[3.2rem] becouse the button is that size and witouth that it would not align properly -->
    <div class="flex h-[3.2rem] flex-row space-between">
        <h3>{{ title() }}</h3>
        @if (isRequestContext() && !hasNewNote()) {
            <mds-icon-button
                [icon]="'add'"
                (clickEvent)="addNote()"
                [tooltip]="'Add note'"
                class="edit-button brand outline"
            ></mds-icon-button>
        }
    </div>
    @for (noteFormGroup of formGroup.controls.notes.controls; let i = $index; track noteFormGroup) {
        <medpace-request-side-notes-item
            [noteFormGroup]="noteFormGroup"
            [context]="context()"
            [objectId]="objectId()"
            [noteIndex]="i"
            (removeNoteEvent)="handleRemoveNote($event)"
        ></medpace-request-side-notes-item>
    }
</div>
